import { BookingPaidCalendar } from 'client/components/entities/booking-paid-calendar'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import EntityInterface from 'common/types/entities/EntityInterface'
import { OfferPriceInterface } from 'common/types/entities/OfferPriceInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import React from 'react'
import { UpsellButtonEntityInterface } from 'src/shared/entities/upsell-button/upsell-button.schema'
import createCommonEntityElement, {
  AdditionalProps,
} from '../createCommonEntityElement'
import { OfferPrice } from '../offer/entities/offer-price'
import UpsellButton from './entities/UpsellButton'

export default function createEntityElementForUpsell(
  entity: EntityInterface | OldEntityInterface,
  additionalProps: AdditionalProps,
) {
  switch (entity.type) {
    case EntityTypeEnum.UpsellAgreeButton:
    case EntityTypeEnum.UpsellDisagreeButton:
      return (
        <UpsellButton
          entity={entity as UpsellButtonEntityInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.OfferPrice:
      return (
        <OfferPrice
          entity={entity as OfferPriceInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BookingPaidCalendar:
      return (
        <BookingPaidCalendar
          entity={entity as BookingPaidCalendarInterface}
          {...additionalProps}
        />
      )
    default:
      return createCommonEntityElement(entity, additionalProps)
  }
}
